// extracted by mini-css-extract-plugin
module.exports = {"container":"az_ATc","label":"az_BTc","productName":"az_CTc","link":"az_DTc"};